var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"busy",style:({ fontSize: (_vm.size + "em") })},[_c('span',{staticClass:"busy__dot"}),_c('span',{staticClass:"busy__dot"}),_c('span',{staticClass:"busy__dot"})])}
var staticRenderFns = []

export { render, staticRenderFns }